import { render, staticRenderFns } from "./GoodsAfterSale.vue?vue&type=template&id=43763048&scoped=true"
import script from "./GoodsAfterSale.vue?vue&type=script&lang=js"
export * from "./GoodsAfterSale.vue?vue&type=script&lang=js"
import style0 from "./GoodsAfterSale.vue?vue&type=style&index=0&id=43763048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43763048",
  null
  
)

export default component.exports